import React from 'react';
import { FaFigma, FaSlack, FaJira ,FaHtml5, FaCss3,FaReact,FaJava} from 'react-icons/fa';
import { SiFramer, SiWebflow, SiNotion,SiJavascript } from 'react-icons/si';
import '../styles/StacksSection.css';

const stacksData = [
    { name: 'Figma', description: 'Interface Design Tool', icon: <FaFigma />, link: 'https://figma.com' },
    { name: 'Framer', description: 'No Code Design Tool', icon: <SiFramer />, link: 'https://framer.com' },
    { name: 'Jira', description: 'Productivity Tool', icon: <FaJira />, link: 'https://jira.com' },
    { name: 'HTML', description: 'Web-Structure Design Tool', icon: <FaHtml5 />, link: 'https://html.com' },
    { name: 'CSS', description: 'Style Tool', icon: <FaCss3 />, link: 'https://jira.com' },
    { name: 'React', description: 'Framework/Component-Based Design Tool', icon: <FaReact />, link: 'https://react.com' },
    { name: 'Javascript', description: 'Logic and Behaviour Tool', icon: <SiJavascript />, link: 'https://javascript.com' },
    { name: 'Notion', description: 'Productivity Tool', icon: <SiNotion />, link: 'https://notion.so' },
    // { name: 'Webflow', description: 'No Code Design Tool', icon: <SiWebflow />, link: 'https://webflow.com' },
    // { name: 'Jira', description: 'Productivity Tool', icon: <FaJira />, link: 'https://jira.com' }
];

const StacksSection = () => {
    return (
        <section className="stacks-section">
            <h2 className="section-title">My Frontend Stack</h2>
            <p className="section-subtitle">Commitment to staying updated with the latest design trends and techniques.</p>
            <div className="stacks-grid">
                {stacksData.map((stack, index) => (
                    <a key={index} href={stack.link} target="_blank" rel="noopener noreferrer" className="stack-card">
                        <div className="stacks-icon">{stack.icon}</div>
                        <div className="stack-info">
                            <h3>{stack.name}</h3>
                            <p>{stack.description}</p>
                        </div>
                        <div className="arrow">→</div>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default StacksSection;
